export default __webpack_public_path__ + "static/media/edit-24px.0d068751.svg";